module.exports = __webpack_public_path__ + "img/shadow-circle-danger.480ad7f5.png";